import React from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonProps, ButtonVariant } from 'src/components/atoms/Button';
import Gap from 'src/components/atoms/Gap';
import { TextVariant } from 'src/components/atoms/Text';
import { StyledUl } from 'src/components/DUP/molecules/WizardUpload/styles';
import { StyledButton } from 'src/pages/DUPPage/styles';
import { Header, HeaderTextContainer, Subtitle, TileContainer, Title } from './styles';

export interface TileProps {
  title: string;
  subtitle?: string;
  content: React.ReactNode | (string | React.ReactNode)[];
  icon?: React.ReactNode;
  button: Partial<ButtonProps>;
  telemetryDataAttributes?: Record<string, string>;
}

const Tile = ({ title, subtitle, icon, button, content, telemetryDataAttributes }: TileProps) => {
  const { t } = useTranslation();
  const buttonProps = {
    ...button,
    name: button.name || 'start',
    variant: button.variant || ButtonVariant.contained,
    children: button.children || t('buttonLabel.start')
  };

  return (
    <TileContainer style={{ flex: 1 }} {...telemetryDataAttributes}>
      <Header>
        <HeaderTextContainer>
          <Title variant={TextVariant.h3} isBold>
            {title}
          </Title>
          <Subtitle variant={TextVariant.small}>{subtitle}</Subtitle>
        </HeaderTextContainer>
        {icon}
      </Header>
      {Array.isArray(content) ? (
        <StyledUl paddingInlineStart="1rem">
          {content.map((item, index) => (
            <li key={`wiz-upload-instruction-${index}`}>{item}</li>
          ))}
        </StyledUl>
      ) : (
        content
      )}
      <Gap height={0.5} />
      <StyledButton {...buttonProps} />
    </TileContainer>
  );
};

export default Tile;
